import './style.css'

const OwnSkeleton = ({ count, circle, width, height, style = {}, wrapperClassName = "" }) => {
    count ||= 1
    style.marginBottom = `${style.marginBottom || count > 1 ? '.25rem' : '.15rem'}`
    const finalStyle = {
        width: `${width ? width + "px" : "100%"}`,
        height: `${height ? height + "px" : "auto"}`,
        ...style
    }

    return Array(count).fill(0).map((_, i) => (
        <span
            key={i}
            className={`react-loading-skeleton ${circle ? 'skeleton-circle' : ''} ${wrapperClassName}`}
            style={finalStyle}
        >&zwnj;</span>
    ))
}

export default OwnSkeleton